import { ComboBox, type ComboBoxOption, type ComboBoxProps } from '../../cdl/ComboBox/ComboBox';
import { useEnums } from '../hooks/useEnums';

export interface EnumComboBoxProps extends Omit<ComboBoxProps<ComboBoxOption>, 'value' | 'onChange' | 'options'> {
    onChange: (option: string) => void;
    enumType: string;
    context?: string;
    value: string;
}

export function EnumComboBox({ enumType, context, onChange, value, ...rest }: EnumComboBoxProps) {
    const { getEnumsForTypeAndContext, getHumanReadableValue } = useEnums();
    const options = Object.keys(getEnumsForTypeAndContext(enumType, context)).map((key: string) => ({
        label: getHumanReadableValue(enumType, key),
        value: key,
    }));
    const isSearchable = rest.isSearchable ?? options.length > 6;

    return (
        <ComboBox
            {...rest}
            value={value || null}
            onChange={(nextValue) => onChange(nextValue ?? '')}
            options={options}
            isSearchable={isSearchable}
        />
    );
}
